import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=3c6b174a"
import script from "./preview.ts?vue&type=script&lang=ts&external"
export * from "./preview.ts?vue&type=script&lang=ts&external"
import style0 from "./preview.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports